module.exports = __WEBPACK_EXTERNAL_MODULE_2__;


//////////////////
// WEBPACK FOOTER
// external "@material/react-ripple/dist/index.js"
// module id = 2
// module chunks = 8 9 12 13 14 15 16 17 20 21 24 25 26 27 44 45 52 53 54 55